import { z } from 'zod';
import { DateSchema, ObjectIdSchema } from './base';

export const TrackerHistoryEntrySchema = z
  .object({
    timestamp: DateSchema.optional(),
    battery: z.number().optional(),
    mcc: z.number().optional(),
    net: z.number().optional(),
    cell: z.number().optional(),
    area: z.number().optional(),
    radio: z.enum(['GSM', 'UMTS', 'CDMA', 'LTE', 'NR']).optional(),
  })
  .transform((data) => ({
    timestamp: data.timestamp,
    battery: data.battery,
    mcc: data.mcc,
    mnc: data.net, // Rename net to mnc
    cellId: data.cell, // Rename cell to cellId
    lac: data.area, // Rename area to lac
    radio: data.radio,
  }));
export const TrackerHistoryEntriesSchema = z.array(TrackerHistoryEntrySchema);

export type TrackerHistoryEntry = z.infer<typeof TrackerHistoryEntrySchema>;
export type TrackerHistoryEntries = z.infer<typeof TrackerHistoryEntriesSchema>;

export const TrackerHistoryEntryPrototypeSchema = z.object({
  trackerId: ObjectIdSchema,
  timestamp: DateSchema,
  battery: z.number().optional(),
  mcc: z.number().optional(),
  net: z.number().optional(),
  cell: z.number().optional(),
  area: z.number().optional(),
  radio: z.string().optional(),
});
export const TrackerHistoryEntriesPrototypeSchema = z.array(TrackerHistoryEntryPrototypeSchema);

export type TrackerHistoryEntryPrototype = z.infer<typeof TrackerHistoryEntryPrototypeSchema>;
export type TrackerHistoryEntriesPrototype = z.infer<typeof TrackerHistoryEntriesPrototypeSchema>;
